const DEFAULT_IMAGE_SRC = "/images/bonusx-logo-large.svg";

export function DefaultLogo() {
  return (
    <picture>
      <source type="image/svg+xml" srcSet={DEFAULT_IMAGE_SRC} />
      <img width={142} height={14} src={DEFAULT_IMAGE_SRC} alt="BonusX" />
    </picture>
  );
}
